import React from "react";
import { Input } from "antd";

const TextInput = ({placeholder, disabled, type, label, onKeyPress, maxLength,  onKeyDown, icon, suffix, ...others}) => {
  return (
    <div>
      <div className={`${label ? "block" : "hidden"} text-left mb-2 text-sm md:text-xl`}>
        <h1>{label}*</h1>
      </div>
      <Input
        size="small"
        placeholder={placeholder}
        className={"shadow"}
        type={type}
        disabled={disabled}
        onKeyPress={onKeyPress}
        maxLength={maxLength}
        onKeyDown={onKeyDown}
        prefix={icon}
        suffix={suffix}
        {...others}
      />
    </div>
  );
};

export default TextInput;

